import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"play\"><path d=\"M29.973 17.28L7.573 30.4c-.96.64-2.24-.107-2.24-1.28V2.88c0-1.173 1.28-1.92 2.24-1.28l22.4 13.12c.96.533.96 2.027 0 2.56z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol